import * as React from 'react';

export const Lottery: React.FunctionComponent = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.75 3.405C12.75 3.336 12.694 3.28 12.625 3.28H3.37501C3.30601 3.28 3.25001 3.336 3.25001 3.405L3.25 12.5955C3.25 12.6645 3.3055 12.72 3.3745 12.72H4.1255C4.1945 12.72 4.25 12.6645 4.25 12.5955L4.25001 4.28H11.75L11.75 11.59C11.75 11.662 11.692 11.72 11.62 11.72H5.7205C5.672 11.72 5.6275 11.7485 5.607 11.793L5.2615 12.543C5.2235 12.6255 5.284 12.72 5.375 12.72H12.041C12.4325 12.72 12.75 12.4025 12.75 12.011L12.75 3.405ZM10.5034 6.09253L9.40084 7.23687L10.5452 8.33947L9.85132 9.05958L8.70698 7.95698L7.60438 9.10132L6.88427 8.40746L7.98687 7.26313L6.84253 6.16053L7.53638 5.44041L8.68072 6.54301L9.78332 5.39868L10.5034 6.09253Z"
        fill="#3A3A3A"
      />
    </svg>
  );
};
